// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"e5475fbb","246":"8d6d3d8c","312":"ff0749d1","342":"86616035","396":"ae3c3ff7","527":"300620ce","894":"e200687b","981":"2b565225"}[chunkId] + ".css";
};